import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { fonts, palette } from "./styles";

// Add global css properties based on js variables
const moreStyles = document.createElement("style");
moreStyles.textContent = `
  body {
    color: ${palette.backgroundTextComplement};
    font-family: ${fonts.sans};
  }
`;
document.head.append(moreStyles);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
